import { render, staticRenderFns } from "./transfer-panel.vue?vue&type=template&id=167ff3ec&scoped=true&"
import script from "./transfer-panel.vue?vue&type=script&lang=js&"
export * from "./transfer-panel.vue?vue&type=script&lang=js&"
import style0 from "./transfer-panel.vue?vue&type=style&index=0&id=167ff3ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167ff3ec",
  null
  
)

export default component.exports